// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f21882be","453":"70bf768f","455":"1764bf19"}[chunkId] + ".chunk.js";
};